import React from "react";

/**
 * ThemeSettings — Sidebar tema ayarları sekmesi
 * NavbarMenu'dan çıkartıldı.
 */
const ThemeSettings = ({ themeColor, onThemeChange }) => {
  const themes = [
    { key: "purple", label: "Mor", className: "purple" },
    { key: "blue", label: "Mavi", className: "blue" },
    { key: "cyan", label: "Camgöbeği", className: "cyan" },
    { key: "green", label: "Yeşil", className: "green" },
    { key: "orange", label: "Turuncu", className: "orange" },
    { key: "blush", label: "Koyu Pembe", className: "blush" },
  ];

  return (
    <>
      <h6>Tema</h6>
      <ul className="choose-skin list-unstyled">
        {themes.map((theme) => (
          <li
            key={theme.key}
            data-theme={theme.key}
            className={themeColor === `theme-${theme.key}` ? "active" : ""}
          >
            <div
              className={theme.className}
              onClick={() => {
                if (themeColor !== `theme-${theme.key}`) {
                  document.body.classList.remove(themeColor);
                }
                onThemeChange(theme.key);
              }}
            ></div>
            <span>{theme.label}</span>
          </li>
        ))}
      </ul>
      <hr />
    </>
  );
};

export default ThemeSettings;
